/* eslint-disable no-template-curly-in-string */
import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  writeSettingsSucceeded: {
    id: 'projectDevicesDirtyActions.writeSettingsSucceeded',
    defaultMessage: 'Write settings succeeded',
  },
})
